"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _vueSvgicon = _interopRequireDefault(require("vue-svgicon"));
/* eslint-disable */
/* tslint:disable */
// @ts-ignore

_vueSvgicon.default.register({
  'puzzle': {
    width: 800,
    height: 800,
    viewBox: '0 0 8 8',
    data: '<path pid="0" d="M3 0c-.28 0-.54.1-.72.28C2.1.46 2 .72 2 1c0 .28.18.48.28.72.03.06.03.16.03.28H0v6h2.31c0-.12-.01-.22-.03-.28C2.18 7.48 2 7.28 2 7c0-.28.1-.54.28-.72C2.46 6.1 2.72 6 3 6c.28 0 .54.1.72.28.18.18.28.44.28.72 0 .28-.18.48-.28.72-.03.06-.03.16-.03.28H6V5.69c.12 0 .22.01.28.03.24.1.44.28.72.28.28 0 .54-.1.72-.28C7.9 5.54 8 5.28 8 5c0-.28-.1-.54-.28-.72C7.54 4.1 7.28 4 7 4c-.28 0-.48.18-.72.28-.06.03-.16.03-.28.03V2H3.69c0-.12.01-.22.03-.28.1-.24.28-.44.28-.72 0-.28-.1-.54-.28-.72C3.54.1 3.28 0 3 0z"/>'
  }
});